import {
  BrowserRouter as Router,
  Routes,
  Route,
} from 'react-router-dom'
import Homepage from './pages/Homepage'
import Gamelobby from './pages/Gamelobby';
import React, { useEffect, useState } from 'react';
import io from 'socket.io-client';
import useLocalStorage from 'use-local-storage'

function App() {
  const [socket, setSocket] = useState(null);
  const [identity, setIdentity] = useState({ id: null, room: null })

  const defaultDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  const [theme, setTheme] = useLocalStorage('theme', defaultDark ? 'dark' : 'light');

  useEffect(() => {
    const newSocket = io(`https://tile-flippers-server.herokuapp.com/`);
    setSocket(newSocket);
    console.log("Socket connection has been established.")
    return () => newSocket.close();
  }, [setSocket]);

  return (
    <div name="themediv" data-theme={theme}>
      <Router>
        <Routes>
          <Route path='/play/*' element={<Gamelobby theme={theme} socket={socket} identity={identity} setIdentity={setIdentity} setTheme={setTheme} />} />
          <Route path='/' element={<Homepage socket={socket} identity={identity} setIdentity={setIdentity} />} />
        </Routes>

      </Router>
    </div>
  )
}

export default App